// index-extras.js — Hero city video switcher + fade-up animations

(function(){
  var dots=document.querySelectorAll('.hero-city-dot');
  var video=document.querySelector('.hero-city-video');
  if(!dots.length||!video)return;
  dots.forEach(function(dot){
    dot.addEventListener('click',function(){
      var city=this.getAttribute('data-city');
      var src=video.getAttribute('data-'+city);
      if(!src||video.src.endsWith(src))return;
      dots.forEach(function(d){d.classList.remove('active');});
      this.classList.add('active');
      video.style.opacity='0';
      setTimeout(function(){
        video.src=src;
        video.load();
        var p=video.play();
        if(p&&p.catch) p.catch(function(){});
        video.style.opacity='1';
      },400);
    });
  });
  video.style.transition='opacity 0.4s ease';
})();

// Block 4.5 (2026-05-19, ADR-027): IntersectionObserver selector list trimmed.
// Selectors удалённых elements (process / advantages / services / reviews / trust-bar
// sections, удалены в Block 4.3) убраны из observer list. KEEP-selectors остаются.
(function(){
  var els=document.querySelectorAll('.fade-up,.blog-card,.top-jk-card,.faq-item');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('visible');});return;}
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){entry.target.classList.add('visible');entry.target.style.opacity='1';entry.target.style.transform='translateY(0)';obs.unobserve(entry.target);}
    });
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  els.forEach(function(el,i){el.style.opacity='0';el.style.transform='translateY(30px)';el.style.transition='opacity 0.7s cubic-bezier(0.16,1,0.3,1) '+i%6*0.1+'s, transform 0.7s cubic-bezier(0.16,1,0.3,1) '+i%6*0.1+'s';obs.observe(el);});
})();
